module.exports = __webpack_public_path__ + "static/media/features-tabs-icon-04.289d0cc9.svg";